import { uniqBy } from 'lodash';
import diff, { Difference } from 'microdiff';

import { UserActivityLogEventDataPoint } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/EmployeeChangeActivityLog/data/index';

export const getDataPointDifferences = (
  oldDataPoints: UserActivityLogEventDataPoint[],
  newDataPoints: UserActivityLogEventDataPoint[],
): Difference[] => {
  const dataPointsToComparisonObject = (
    dps: UserActivityLogEventDataPoint[],
  ) => {
    return Object.fromEntries(
      dps.map(({ key, value }) => {
        return [key, value];
      }),
    );
  };

  return diff(
    dataPointsToComparisonObject(oldDataPoints),
    dataPointsToComparisonObject(newDataPoints),
  );
};

export const convertDifferenceToDataPoint = (
  difference: Difference,
  allDataPoints: UserActivityLogEventDataPoint[],
) => {
  const differenceType = difference.type;
  const key = difference.path.join('.');
  const label =
    allDataPoints.find(({ key: dpKey }) => key === dpKey)?.label ?? key;

  switch (differenceType) {
    case 'REMOVE': {
      return {
        key,
        label,
        value: `${difference.oldValue} =>`,
        differenceType,
      };
    }
    case 'CHANGE': {
      return {
        key,
        label,
        value: `${difference.oldValue} => ${difference.value}`,
        differenceType,
      };
    }

    case 'CREATE': {
      return {
        key,
        label,
        value: `=> ${difference.value}`,
        differenceType,
      };
    }
  }
};

export const resolveDataPointChanges = (
  oldDataPoints: UserActivityLogEventDataPoint[],
  newDataPoints: UserActivityLogEventDataPoint[],
) => {
  const allDataPoints = uniqBy(oldDataPoints.concat(newDataPoints), 'key');

  return getDataPointDifferences(oldDataPoints, newDataPoints).map((d) =>
    convertDifferenceToDataPoint(d, allDataPoints),
  );
};
